import state from './dashboardState'
import mutations from './dashboardMutations'
import actions from './dashboardActions'
import getters from './dashboardGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
